import { arrayMove } from "react-sortable-hoc";
let getEmptyCase = _ => ({
  currentStep: 0,
  orderingMode: false,
  images: [],
  info: {
    title: "",
    description: "",
    caseType: "",
  },
  publishing: false,
});

const NewCase = (state = getEmptyCase(), action) => {
  switch (action.type) {
    case "ON_SORT_END":
      return {
        ...state,
        images: arrayMove(state.images, action.oldIndex, action.newIndex),
      };

    case "GET_GUID_SUCCESS":
      return {
        ...state,
        guid: action.guid.data,
      };

    case "HANDLE_STEP_CHANGE":
      return {
        ...state,
        currentStep: state.currentStep + action.stepIncrement,
        orderingMode: action.orderingModeToggle ? !state.orderingMode : state.orderingMode,
      };

    case "HANDLE_CHOOSING_IMGAES":
      return { ...state, images: [...state.images, ...action.images] };

    case "HANDLE_UPLOADED_IMGAE":
      return {
        ...state,
        images: state.images.map(
          img =>
            img.id === action.name
              ? {
                  ...img,
                  fileId: action.id,
                  uploaded: true,
                  uuid: action.uuid,
                }
              : img
        ),
      };

    case "TOGGLE_COVER_IMAGE":
      return {
        ...state,
        images: state.images.map(
          ({ isCover, ...image }) => (image.id === action.coverImageId ? { ...image, isCover: !isCover } : { ...image })
        ),
      };

    case "UPDATE_CAPTION":
      return {
        ...state,
        images: state.images.map(
          image =>
            image.id === action.imageId
              ? {
                  ...image,
                  caption: action.caption,
                }
              : image
        ),
      };

    case "DELETE_IMAGE":
      return {
        ...state,
        images: state.images.filter(image => image.id !== action.imageId),
      };

    case "HANDLE_INFO_CHANGE":
      return {
        ...state,
        info: {
          ...state.info,
          ...action.changesObj,
        },
      };

    case "PUBLISH_REQUEST":
      return {
        ...state,
        publishing: true,
      };

    case "PUBLISH_SUCCESS":
      return getEmptyCase();

    case "PUBLISH_FAILED":
      return {
        ...state,
        publishing: false,
      };

    default:
      return state;
  }
};

export default NewCase;



// WEBPACK FOOTER //
// ./src/reducers/NewCase/index.js